import { makeStyles } from "@mui/styles";
import { lightGreen } from "../../../constants/colors";

export default makeStyles((theme) => ({
  socialMediaContainer: {
    display: "flex",
    padding: 0,
    border: "1px solid",
    borderColor: theme.palette.secondary.main,
    borderRadius: 2,
    alignItems: "center",
    outline: "none",
    "& .MuiFormControl-root": {
      outline: "none !important",
    },
  },
  textField: {
    width: 100,
    borderRadius: "50%",
    outline: "none",
    borderWidth: 0,
    userSelect: "none",
    height: "56px",
    color: theme.palette.mainText,

    height: "56px",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
      padding: 0,
    },
  },

  autoCompleteInput: {
    color: theme.palette.mainText,
  },

  socialMediaIconContainer: {
    backgroundColor: theme.palette.secondary.main,
    margin: "0 auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderTopLeftRadius: 4.5,
    borderBottomLeftRadius: 4.5,
    minWidth: 60,
  },
  addIcon: {
    fontSize: "24px",
  },
  removeIcon: {
    fontSize: "24px",
    color: lightGreen,
  },
  helperTextContainer: {
    marginLeft: 14,
    marginRight: 14,
    marginTop: 0,
  },
  helperText: {
    margin: 0,
    color: "#B00020",
    fontSize: "0.75rem",
    marginTop: 1,
    textAlign: "left",
    fontFamily: "Montserrat,Arial,sans-serif,Helvetica Neue,Helvetica",
    fontWeight: 400,
    lineHeight: "1.66",
  },
}));
